module.exports = __webpack_public_path__ + "static/media/ico-projetos.9f9fbe02.svg";